// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/calendar/style/index.less
// module id = 1078
// module chunks = 1